// See /src/server/utilities/create-vod-hls.sh
export const HLS_START_LEVEL = 1; // Start with 2nd rendition
